import { VehicleStatusEnum } from 'common/enums/vehicle-status.enum';
import { IVehicleRead } from 'common/services/residents-service/residents.service.types';

export const getVehicleRowClassName = (rowIndex: number, rowData: IVehicleRead): string => {
  return rowData?.status === VehicleStatusEnum.Deleted ? 'deleted-record-row' : '';
};
